const SERVICES = [
  {
    eyebrow: "01",
    title: "Product strategy",
    body: "Sharpen what you're building and why. Discovery sprints, roadmap surgery, and the briefs your team actually needs.",
  },
  {
    eyebrow: "02",
    title: "Interface design",
    body: "Interfaces that feel inevitable. From concept exploration to a working design system your engineers can pick up and run with.",
  },
  {
    eyebrow: "03",
    title: "Platform engineering",
    body: "Cloud-native foundations, observability, and CI that scale with the team. Less yak-shaving, more shipping.",
  },
  {
    eyebrow: "04",
    title: "AI integration",
    body: "Practical AI features grounded in your data — evaluations, guardrails, and the boring plumbing that makes them production-safe.",
  },
];

export default function Services() {
  return (
    <section className="section" id="services">
      <div className="container">
        <header className="section-header">
          <p className="section-eyebrow">What we do</p>
          <h2 className="section-title">A small senior team, embedded with yours.</h2>
          <p className="section-lede">
            No layers, no handoffs. The people you meet in week one are the people in
            the pull requests in week four.
          </p>
        </header>
        <div className="card-grid">
          {SERVICES.map((s) => (
            <article key={s.title} className="card">
              <p className="card-eyebrow">{s.eyebrow}</p>
              <h3 className="card-title">{s.title}</h3>
              <p className="card-body">{s.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
